var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNovuEmptyInboxinline = function SvgNovuEmptyInboxinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.97 9.5a1.1 1.1 0 0 0-.16-.35c-.008-.011-.01-.024-.017-.036-.005-.008-.014-.011-.02-.019a1 1 0 0 0-.218-.22L13.635.207a1.08 1.08 0 0 0-1.274 0L.446 8.874a1.1 1.1 0 0 0-.22.221c-.005.008-.014.01-.02.018-.007.01-.008.023-.015.035a1.1 1.1 0 0 0-.162.352q0 .01-.002.019A1 1 0 0 0 0 9.75v13A3.254 3.254 0 0 0 3.25 26h19.5A3.254 3.254 0 0 0 26 22.75v-13q0-.116-.027-.23zM12.999 2.423l10.076 7.328-10.074 7.327L2.925 9.751z"
  })));
};
export default SvgNovuEmptyInboxinline;